import { useEffect } from 'react';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import useGradesTableStore from '../store/useGradesTableStore';

const useSubmissions = () => {
  const isLoadingAssignments = useGradesTableStore(state => state.isLoadingAssignments);
  const assignments = useGradesTableStore(state => state.assignments);
  const setStore = useGradesTableStore(state => state.setStore);
  const studentId = useGradesTableStore(state => state.student.id);

  useEffect(() => {
    if (isLoadingAssignments) return;

    const searchParams = {
      except: ['graded_status'],
      for_assignments: assignments.map(a => a.id),
      for_student: studentId,
    };

    axios.get(Routes.plato_api_submissions_path(searchParams))
      .then((res) => {
        setStore({ submissions: res.data.data || [] });
      })
      .finally(() => setStore({ isLoading: false }));
  }, [isLoadingAssignments]);
};

export default useSubmissions;
